import React, { ReactElement } from "react";
import "./card.scss";

export interface CardProps {
    title?: string;
    iconText?: string;
    icon?: ReactElement;
    className?: string;
    info?: ReactElement;
}

export const Card: React.FC<CardProps> = (props) => {
    return (
        <div className="card-address">
            <div className="card-header">
                <div className="card-header-title">
                    {props.title}
                    {props.info && props.info}
                </div>
                {props.icon && <div className="card-header-icon">
                    {props?.iconText}{props.icon}
                </div>}
            </div>
            <div className={`card-body ${props.className}`}>
                {props.children}
            </div>
        </div>
    );
};

export default Card;
